import { render, staticRenderFns } from "./x-radio-button-large.vue?vue&type=template&id=263ca64c&scoped=true&"
import script from "./x-radio-button-large.vue?vue&type=script&lang=js&"
export * from "./x-radio-button-large.vue?vue&type=script&lang=js&"
import style0 from "./x-radio-button-large.vue?vue&type=style&index=0&id=263ca64c&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263ca64c",
  null
  
)

export default component.exports